interface StatColumnProps {
  label: string
  value: React.ReactNode
  columnClasses?: string
  labelClasses?: string
  dataClasses?: string
}

export const StatColumn = ({
  label,
  value,
  columnClasses = 'flex flex-col gap-2 py-2 pr-6 md:p-0',
  labelClasses = 'text-xs md:text-sm text-text-secondary',
  dataClasses = 'font-medium text-sm md:text-base',
}: StatColumnProps) => (
  <div className={columnClasses}>
    <span className={labelClasses}>{label}</span>
    <span className={dataClasses}>{typeof value === 'string' ? value : value}</span>
  </div>
)
